import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "..";

interface IMenuSlice {
  menuActive: string[];
}

const initialState: IMenuSlice = {
  menuActive: [],
};

const menuSlice = createSlice({
  name: "MENU",
  initialState,
  reducers: {
    changeMenuActive: (state, action: PayloadAction<string[]>) => {
      const value = action.payload;
      state.menuActive = value;
    },
  },
});

export default menuSlice.reducer;

export const getMenuActive = (state: RootState) => state.menus.menuActive;
